var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome"},[_c('div',{staticClass:"youtube-video"},[_c('iframe',{attrs:{"src":"https://www.youtube.com/embed/8nJON6B0xFU","title":"YouTube video player","frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}}),_c('p',[_vm._v("Click here to continue...")])])])
}]

export { render, staticRenderFns }